import React from 'react';

const DialButton = (props) => {
    const { color, radio } = props;
    return (
        <button type="button" className={'btn_tel_' + color} onClick={() => radio.pressButton(color)}>
            <img src={'/images/icons/radio/telephone-fill-' + color + '.svg'} />
        </button>
    );
};

export default DialButton;
